module.exports = __webpack_public_path__ + "media/assets/placeholder/avatar_placeholder-471a1ad342659289433e05a611d206f8.png";